import React from 'react';
import { useState } from 'react';
import moment from 'moment';
import CustomDatePicker from './CustomDatePicker';
import clsx from 'clsx';

export interface SelectedDateRange {
  from: string;
  to: string;
}
interface Props {
  children?: React.ReactNode;
  onSubmit: (data: SelectedDateRange) => void;
  classes?: string;
  fromDate?: Date;
  toDate?: Date;
}

function DashboardDatePickers({ onSubmit, classes, fromDate, toDate }: Props) {
  const [startDate, setStartDate] = useState<Date | null>(fromDate ?? new Date());
  const [endDate, setEndDate] = useState<Date | null>(toDate ?? new Date());

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
  };

  const submit = () => {
    const data = {
      from: moment(startDate).format('YYYY-MM-DD'),
      to: moment(endDate).format('YYYY-MM-DD')
    };
    onSubmit(data);
  };

  return (
    <div className={clsx("datepickers flex-col xl:flex xl:flex-row items-center mt-2 sm:mt-0", classes)}>
      <div className="px-0 lg:px-3">
        <CustomDatePicker
          selectedDate={startDate}
          onChange={handleStartDateChange}
          placeholderText="Start Date"
          dateFormat='dd/MM/yyyy'
        />
      </div>
      <span className="text-center lg:pl-1">to</span>
      <div className="px-0 lg:px-2">
        <CustomDatePicker
          selectedDate={endDate}
          onChange={handleEndDateChange}
          placeholderText="End Date"
          dateFormat='dd/MM/yyyy'
        />
      </div>
      <button
        disabled={!startDate || !endDate}
        onClick={submit}
        className="bg-primary-main text-white rounded py-1 px-4 mt-4 sm:mt-0 disabled:bg-red md:mt-4 lg:ml-3 lg:mt-3 xl:mt-0 text-sm mb-2 lg:mb-0">
        Check
      </button>
    </div>
  );
}

export default DashboardDatePickers;
